import React from "react";
import balanceText from "balance-text";

export default function useBalancedText(...refs) {
  React.useLayoutEffect(() => {
    let ignore = false;

    function balance() {
      const nodes = refs.map(getRefCurrent).filter(Boolean);

      if (!ignore && nodes.length > 0) {
        balanceText(nodes);
      }
    }

    balance();

    window.addEventListener("resize", balance);

    return () => {
      ignore = true;
      window.removeEventListener("resize", balance);
    };
    /* eslint-disable-next-line */
  }, refs);
}

function getRefCurrent(ref) {
  return ref.current;
}
